import { useState, useEffect } from 'react';

import ReviewColumns from './reviewColumns';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

import Table from '../../components/Table/Table';
import StyledWrapper from '../IndividualProgram/style';
import {
	useGetActiveUserReviewsQuery,
	useGetInactiveUserReviewsQuery
} from '../../services/endpoints/programsEndpoints';
import usePaginatedCall from '../../hooks/usePaginatedCall';

const UserReviews = () => {
	const [showNoReviewsAlert, setShowNoReviewsAlert] = useState(false);
	const activeReviewsPagination = usePaginatedCall(useGetActiveUserReviewsQuery, {
		filterBaseName: 'USER_REVIEWS'
	});
	const inactiveReviewsPagination = usePaginatedCall(useGetInactiveUserReviewsQuery, {
		filterBaseName: 'USER_REVIEWS'
	});

	useEffect(() => {
		setShowNoReviewsAlert(
			((!activeReviewsPagination.loading && !activeReviewsPagination?.rows?.results) ||
				activeReviewsPagination?.rows?.results?.length === 0) &&
				((!inactiveReviewsPagination.loading && !inactiveReviewsPagination?.rows?.results) ||
					inactiveReviewsPagination?.rows?.results?.length === 0)
		);
	}, [activeReviewsPagination, inactiveReviewsPagination]);

	const theme = createTheme({
		palette: {
			secondary: {
				main: '#9C27B0'
			}
		}
	});

	const activeReviewTableColumns = ReviewColumns(true);
	const inactiveReviewTableColumns = ReviewColumns(false);

	return (
		<ThemeProvider theme={theme}>
			{showNoReviewsAlert ? (
				<Stack sx={{ width: '100%' }} spacing={2}>
					<Alert variant="outlined" severity="info">
						There are no reviews assigned to you
					</Alert>
					<br />
				</Stack>
			) : (
				<>
					<StyledWrapper.TableContainer>
						<h4
							style={{
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								paddingBottom: '30px'
							}}
						>
							Active Reviews
						</h4>

						<Table
							getRowId={(cell) => cell.review_unique_identifier}
							columns={activeReviewTableColumns}
							rowHeight={true}
							enableAutoPageSize
							rows={activeReviewsPagination?.rows?.results || []}
							rowCount={activeReviewsPagination?.rowCount}
							pagination={activeReviewsPagination?.pagination}
							pageSize={activeReviewsPagination?.pageSize}
							paginationMode={activeReviewsPagination?.paginationMode}
							onPageChange={(e) => activeReviewsPagination?.onPageChange(e)}
							onPageSizeChange={(e) => activeReviewsPagination?.onPageSizeChange(e)}
							page={activeReviewsPagination?.page}
							loading={activeReviewsPagination?.loading}
							sortingMode={activeReviewsPagination?.sortingMode}
							onSortModelChange={(e) => activeReviewsPagination?.onSortModelChange(e)}
							onFilterModelChange={(e) => activeReviewsPagination?.onFilterModelChange(e)}
							filterModel={activeReviewsPagination?.filterModel}
							sortModel={activeReviewsPagination?.sortModel}
							hideFilters={true}
						/>
					</StyledWrapper.TableContainer>
					<StyledWrapper.TableContainer>
						<h4
							style={{
								width: '100%',
								display: 'flex',
								justifyContent: 'center',
								paddingBottom: '30px'
							}}
						>
							Inactive Reviews
						</h4>

						<Table
							getRowId={(cell) => cell.review_unique_identifier}
							columns={inactiveReviewTableColumns}
							rowHeight={true}
							enableAutoPageSize
							rows={inactiveReviewsPagination?.rows?.results || []}
							rowCount={inactiveReviewsPagination?.rowCount}
							pagination={inactiveReviewsPagination?.pagination}
							pageSize={inactiveReviewsPagination?.pageSize}
							paginationMode={inactiveReviewsPagination?.paginationMode}
							onPageChange={(e) => inactiveReviewsPagination?.onPageChange(e)}
							onPageSizeChange={(e) => inactiveReviewsPagination?.onPageSizeChange(e)}
							page={inactiveReviewsPagination?.page}
							loading={inactiveReviewsPagination?.loading}
							sortingMode={inactiveReviewsPagination?.sortingMode}
							onSortModelChange={(e) => inactiveReviewsPagination?.onSortModelChange(e)}
							onFilterModelChange={(e) => inactiveReviewsPagination?.onFilterModelChange(e)}
							filterModel={inactiveReviewsPagination?.filterModel}
							sortModel={inactiveReviewsPagination?.sortModel}
							hideFilters={true}
						/>
					</StyledWrapper.TableContainer>
				</>
			)}
		</ThemeProvider>
	);
};

export default UserReviews;
